import { createContext, useContext } from "react";
import frFR from "./locales/fr-FR.json";
import enUS from "./locales/en-US.json";

export type Locale = "fr-FR" | "en-US";

export type Translations = typeof frFR;

const locales: Record<Locale, Translations> = {
  "fr-FR": frFR,
  "en-US": enUS,
};

export function getTranslations(locale: Locale): Translations {
  return locales[locale] ?? frFR;
}

export const DEFAULT_LOCALE: Locale = "fr-FR";

export function isValidLocale(value: string | undefined): value is Locale {
  return value === "fr-FR" || value === "en-US";
}

export function parseLocale(value: string | undefined): Locale {
  if (isValidLocale(value)) return value;
  return DEFAULT_LOCALE;
}

// React context
type LocaleContextValue = {
  locale: Locale;
  t: Translations;
};

export const LocaleContext = createContext<LocaleContextValue>({
  locale: DEFAULT_LOCALE,
  t: frFR,
});

export function useTranslations() {
  return useContext(LocaleContext);
}
